import {Exir} from "../../ui";
import {h} from "../../ui/h";
// import Exir from "exir/ui";
import TodoList from "./views/TodoList";
// import {BasicRouter, Route} from "exir/ui/router/basic";

export default Exir.createComponent({
    name:'App',
    render() {
        return <div style={{margin: 'auto', textAlign: 'center'}}>
            <div className="flex items-center justify-center">
                <div className="w-full flex items-center justify-center bg-teal-lightest font-sans">
                    <div className="bg-white rounded shadow p-6 m-4 w-full lg:w-3/4 lg:max-w-lg">
                        <h1 className="text-xl font-bold">Todo List</h1>
                        <TodoList/>
                    </div>
                </div>
            </div>
        </div>
    }
})